import { useState } from "react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, ShieldOff } from "lucide-react";
import { toast } from "sonner";

export default function Profilo() {
  const { user, refreshUser } = useAuth();
  const [qr, setQr] = useState(null);
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");

  const setup = async () => {
    try { const { data } = await api.post("/auth/2fa/setup"); setQr(data); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };
  const activate = async () => {
    try { await api.post("/auth/2fa/activate", { code }); toast.success("2FA attivata");
      setQr(null); setCode(""); await refreshUser(); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };
  const disable = async () => {
    try { await api.post("/auth/2fa/disable", { password }); toast.success("2FA disattivata");
      setPassword(""); await refreshUser(); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };

  return (
    <div className="max-w-2xl space-y-5">
      <h1 className="text-2xl font-heading font-black">Profilo</h1>
      <Card className="p-5 rounded-md">
        <div className="font-heading font-bold">Account</div>
        <div className="text-sm mt-2 space-y-1">
          <div><span className="text-muted-foreground">Username:</span> <span className="font-mono">{user?.username}</span></div>
          <div><span className="text-muted-foreground">Email:</span> <span className="font-mono">{user?.email}</span></div>
          <div><span className="text-muted-foreground">Ruolo:</span> <span className="font-mono">{user?.role}</span></div>
        </div>
      </Card>
      <Card className="p-5 rounded-md">
        <div className="font-heading font-bold flex items-center gap-2">
          {user?.two_factor_enabled ? <ShieldCheck className="w-5 h-5 text-green-600" /> : <ShieldOff className="w-5 h-5 text-muted-foreground" />}
          Autenticazione a due fattori
        </div>
        {user?.two_factor_enabled ? (
          <div className="mt-3 space-y-3">
            <div className="text-sm text-muted-foreground">La 2FA è attiva. Per disattivarla inserisci la password.</div>
            <div className="flex gap-2">
              <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-9 max-w-xs" />
              <Button variant="destructive" onClick={disable} data-testid="disable-2fa-button">Disattiva 2FA</Button>
            </div>
          </div>
        ) : !qr ? (
          <div className="mt-3">
            <div className="text-sm text-muted-foreground mb-3">Attiva l'autenticazione a due fattori per maggior sicurezza. Avrai bisogno di un'app come Google Authenticator o Authy.</div>
            <Button onClick={setup} data-testid="setup-2fa-button">Attiva 2FA</Button>
          </div>
        ) : (
          <div className="mt-3 space-y-3">
            <div className="text-sm">Scansiona questo QR con l'app autenticatore:</div>
            <img src={qr.qr} alt="QR 2FA" className="w-48 h-48 border rounded-sm" />
            <div className="text-xs font-mono bg-muted p-2 rounded-sm break-all">Secret: {qr.secret}</div>
            <Label className="text-xs font-heading uppercase">Inserisci codice a 6 cifre</Label>
            <div className="flex gap-2">
              <Input value={code} onChange={(e) => setCode(e.target.value)} className="h-9 w-40 font-mono" placeholder="123456" />
              <Button onClick={activate} data-testid="activate-2fa-button">Conferma attivazione</Button>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
}
